import { createApi } from '@reduxjs/toolkit/query/react';
import dteAdapter, { DteApi } from '@/models/adapters/dte.adapter';
import Dte from '@/models/respuestas/dte.model';
import RespuestaApi from '@/models/respuestas/resApi.model';
import { DOCUMENTOS } from '@/helpers/urls';
import { GET } from '@/providers/api';
import axiosBaseQuery from './axiosBaseQuery';

export const dteApi = createApi({
  reducerPath: 'dteApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    obtenerDtes: builder.query<Dte[], string>({
      query: () => ({ endpoint: DOCUMENTOS, method: GET }),
      transformResponse: (res: RespuestaApi<DteApi[]>) =>
        dteAdapter(res.resultado),
      transformErrorResponse: () => [] as Dte[],
      keepUnusedDataFor: 30,
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg;
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useObtenerDtesQuery, useLazyObtenerDtesQuery } = dteApi;
